module.exports = __webpack_public_path__ + "img/bonyad-shahid.4bcda88.svg";